import { useContext } from 'react';
import { AppContext } from '../providers/AppProvider';

const useApp = () => {
    const {
        token,
        setToken,
        loginError,
        setLoginError,
        theme,
        setTheme,
        currentPage,
        setCurrentPage,
        organization,
        setOrganization,
        company,
        setCompany,
        companyName,
        setCompanyName,
        wabaIdSelected,
        setWabaIdSelected,
    } = useContext(AppContext);

    const logout = () => {
        setToken('');
    };

    return {
        logout,
        token,
        setToken,
        loginError,
        setLoginError,
        theme,
        setTheme,
        currentPage,
        setCurrentPage,
        organization,
        setOrganization,
        company,
        setCompany,
        companyName,
        setCompanyName,
        wabaIdSelected,
        setWabaIdSelected,
    };
};

export default useApp;
